import { useDateFormatter } from '@mint-lib/formatting-hooks';
import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';
import type { Schedule } from '@mint-sdk/api-ai-assistant';

const ScheduledChatInfo = ({
  scheduleDetails,
}: {
  scheduleDetails: Schedule.QueryScheduleSchemaType;
}) => {
  const { t } = useTranslation('@mint-lib/ai-chat');
  const dateFormatter = useDateFormatter(
    new Date(scheduleDetails.startDate),
    new Date(scheduleDetails.endDate),
  );

  const secondaryCaption = typographyVariants({
    variant: 'caption2',
    color: 'secondary',
  });
  const boldCaption = cn(secondaryCaption, 'font-bold');

  return (
    <div className="flex flex-wrap items-center gap-1">
      <div className="flex gap-0.5">
        <p className={secondaryCaption}>{t('Scheduled')}:</p>
        <p className={cn(boldCaption, 'capitalize')}>
          {scheduleDetails.scheduling}
        </p>
      </div>
      <span> - </span>
      <div className="flex gap-0.5">
        <p className={secondaryCaption}>{t('Date range')}:</p>
        <p className={boldCaption}>{dateFormatter.formattedDateRange}</p>
      </div>
      <span> - </span>
      <div className="flex gap-0.5">
        <p className={secondaryCaption}>{t('Time')}:</p>
        <p className={boldCaption}>
          {dateFormatter.formatDate(
            new Date(scheduleDetails.startDate + 'Z'),
            'hh:mm a', // 08:00 PM
          )}
        </p>
      </div>
    </div>
  );
};

export { ScheduledChatInfo };
